// extracted by mini-css-extract-plugin
export default {"firmas":"Firmas_firmas__Y3J0d","confirm":"Firmas_confirm__IY10f","error":"Firmas_error__ffiCD","actions":"Firmas_actions__2sLnW","download":"Firmas_download__6sbEq"};